import React from "react";

export const PageLoading = () => {
  return <div>Loading...</div>;
};
